// embedParams — read the embed-mode inputs from the URL (Phase 3a, step 12).
//
// The embed entry is driven entirely by query params (+ an optional postMessage
// handshake) instead of window.location path / Redux / localStorage, so a
// self-service page or single special component can be rendered inside an iframe
// on a client's own site, or by the builder live-preview
// (see ce-ui docs/SELF_SERVICE_PLAN.md §5.3C, §6.6, Phase 3a).
//
// Recognised params (all optional except an asset reference):
//   embed=1                turns on embed mode (no Header/Footer, no chrome)
//   assetCode | asset      assetURLCode of the asset
//   assetID                assetID (alternative to assetCode)
//   widget                 render a single widget by registry name
//                          (Map|ProposedSite|FeedbackForm|ShareIdeas|Chat2|Story)
//   page | slug            render a self-service page by slug
//   preview=draft          render the draft (builder live-preview; needs a token)
//   token                  bootstrap token (otherwise fetched via getCeEmbedToken
//                          for published embeds, or pushed over postMessage)
//   storyId                storyId for the Story widget

const truthy = (v) => v === "1" || v === "true" || v === "yes";

export const isEmbedMode = (search = (typeof window !== "undefined" ? window.location.search : "")) => {
  try {
    return truthy(new URLSearchParams(search).get("embed"));
  } catch (e) {
    return false;
  }
};

export const readEmbedParams = (search = (typeof window !== "undefined" ? window.location.search : "")) => {
  const q = new URLSearchParams(search);
  return {
    embed: truthy(q.get("embed")),
    assetCode: q.get("assetCode") || q.get("asset") || undefined,
    assetID: q.get("assetID") || undefined,
    widget: q.get("widget") || undefined,
    pageSlug: q.get("page") || q.get("slug") || undefined,
    preview: q.get("preview") === "draft" ? "draft" : undefined,
    token: q.get("token") || undefined,
    storyId: q.get("storyId") || undefined,
    // Render the self-service header/footer around the page (builder
    // live-preview WYSIWYG); menu clicks emit CE_EMBED_NAVIGATE to the host.
    chrome: truthy(q.get("chrome")),
  };
};
